(() => {
  function init(form) {
    if (form.dataset.adSearchBound) return;
    form.dataset.adSearchBound = 'true';
    const input = form.querySelector('input[name="q"]');
    const panel = form.querySelector('[data-ad-search-panel]');
    const list = form.querySelector('[data-ad-search-list]');
    const status = form.querySelector('[data-ad-search-status]');
    const all = form.querySelector('[data-ad-search-all]');
    const cache = new Map();
    let timer, controller, sequence = 0, selected = -1;
    const money = new Intl.NumberFormat('es-CL', {
      style: 'currency', currency: form.dataset.currency || 'CLP', maximumFractionDigits: 0
    });
    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      select(-1);
    }
    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function select(index) {
      const options = [...list.children];
      selected = index;
      options.forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
      if (options[index]) {
        input.setAttribute('aria-activedescendant', options[index].id);
        options[index].scrollIntoView({ block: 'nearest' });
      } else input.removeAttribute('aria-activedescendant');
    }
    function searchLink(query) {
      const url = new URL(form.action, location.origin);
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', query);
      all.href = url.href;
      all.textContent = `Ver todos los resultados de «${query}» →`;
    }
    function render(products, query) {
      list.replaceChildren();
      selected = -1;
      input.removeAttribute('aria-activedescendant');
      products.slice(0, 6).forEach((product, i) => {
        const destination = new URL(product.url, location.origin);
        if (destination.origin !== location.origin) return;
        const row = document.createElement('li');
        row.id = `${list.id}-product-${i}`;
        row.setAttribute('role', 'option');
        row.setAttribute('aria-selected', 'false');
        const link = document.createElement('a');
        link.href = destination.href;
        link.tabIndex = -1;
        link.className = 'ad-search-result';
        const photo = product.featured_image?.url || product.image;
        if (photo) {
          const image = document.createElement('img');
          const src = new URL(photo, location.origin);
          src.searchParams.set('width', '112');
          image.src = src.href;
          image.alt = '';
          image.width = 56;
          image.height = 56;
          image.loading = 'eager';
          link.append(image);
        }
        const info = document.createElement('span');
        info.className = 'ad-search-result-info';
        const title = document.createElement('strong');
        title.textContent = product.title;
        const price = document.createElement('small');
        const amount = Number(product.price_min ?? product.price);
        price.textContent = Number.isFinite(amount) ? `${product.price_min !== product.price_max ? 'Desde ' : ''}${money.format(amount)}` : 'Ver opciones';
        if (!product.available) price.textContent += ' · Consultar disponibilidad';
        info.append(title, price);
        link.append(info);
        row.append(link);
        list.append(row);
      });
      status.textContent = list.children.length ? 'Muebles que coinciden con tu búsqueda' : 'No encontramos coincidencias. Prueba con otro nombre o revisa los resultados.';
      searchLink(query);
      open();
    }
    async function load(query, ticket) {
      if (cache.has(query)) {
        render(cache.get(query), query);
        return;
      }
      list.replaceChildren();
      select(-1);
      status.textContent = 'Buscando muebles…';
      searchLink(query);
      open();
      controller = new AbortController();
      const url = new URL(form.dataset.suggestUrl, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      try {
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (ticket !== sequence || input.value.trim() !== query || !form.contains(document.activeElement)) return;
        const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const terms = normalize(query).split(/\s+/).filter(Boolean);
        const products = (data.resources?.results?.products || []).filter(product => {
          const searchable = normalize([product.title, product.product_type, product.vendor, product.tags].join(' '));
          return terms.every(term => searchable.includes(term));
        });
        if (cache.size >= 25) cache.delete(cache.keys().next().value);
        cache.set(query, products);
        render(products, query);
      } catch (error) {
        if (error.name === 'AbortError' || ticket !== sequence) return;
        status.textContent = 'Puedes ver los resultados completos de tu búsqueda.';
        list.replaceChildren();
        searchLink(query);
        open();
      }
    }
    input.addEventListener('input', () => {
      clearTimeout(timer);
      controller?.abort();
      const query = input.value.trim();
      const ticket = ++sequence;
      close();
      if (query.length >= 2) timer = setTimeout(() => load(query, ticket), 220);
    });
    input.addEventListener('focus', () => {
      const query = input.value.trim();
      if (query.length >= 2) load(query, ++sequence);
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        ++sequence;
        clearTimeout(timer);
        controller?.abort();
        close();
      } else if (!panel.hidden && ['ArrowDown', 'ArrowUp'].includes(event.key) && list.children.length) {
        event.preventDefault();
        const length = list.children.length;
        select(event.key === 'ArrowDown' ? (selected + 1) % length : (selected < 0 ? length - 1 : (selected - 1 + length) % length));
      } else if (event.key === 'Enter' && !panel.hidden && selected >= 0) {
        event.preventDefault();
        list.children[selected].querySelector('a').click();
      }
    });
    form.addEventListener('focusout', () => {
      setTimeout(() => { if (!form.contains(document.activeElement)) { ++sequence; clearTimeout(timer); controller?.abort(); close(); } }, 0);
    });
    document.addEventListener('pointerdown', event => {
      if (!form.contains(event.target)) { ++sequence; clearTimeout(timer); controller?.abort(); close(); }
    });
    const initialQuery = input.value.trim();
    if (initialQuery.length >= 2 && form.contains(document.activeElement)) load(initialQuery, ++sequence);
  }
  document.querySelectorAll('[data-ad-predictive-search]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-ad-predictive-search]').forEach(init);
  });
})();
